/* eslint-disable no-param-reassign */
import { TimelineMax } from 'gsap/TweenMax';

export default function () {
  const accordionBtns = document.querySelectorAll('[data-type*="accordion-btn"]');
  if (!accordionBtns.length) return;

  Array.from(accordionBtns).forEach((btn) => {
    const container = btn.closest('.accordion');
    const contentId = btn.dataset.accordionContentId;
    btn.content = container.querySelector(`[data-accordion-content="${contentId}"]`);
    btn.contentChildren = btn.content.children;

    btn.tl = new TimelineMax({
      reversed: true,
      paused: true,
    });

    btn.tl.from(btn.content, 0.5, { className: '+=heightZero' }, 'open');
    btn.tl.staggerFrom(btn.contentChildren, 0.5, { autoAlpha: 0, y: -100 }, 0.1, 'open+=.1');

    btn.addEventListener('click', function () {
      if (this.tl.reversed()) {
        this.classList.add('active');
        this.tl.play();
      } else {
        this.classList.remove('active');
        this.tl.reverse();
      }
    });
  });
}
/* eslint-enable no-param-reassign */



// WEBPACK FOOTER //
// ./scripts/blocks/accordions.js